import { HTTP, authHeader } from './http-service';

class PersonRegistrationService {
  get(payload) {
    return HTTP.get(`/TrustmarkPerson/${payload.trustmarkPersonId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getBusinessRegistrations(trustmarkPersonId) {
    return HTTP.get(`/TrustmarkPerson/${trustmarkPersonId}/business-registrations`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data.model;
    });
  }

  create(payload) {
    return HTTP.post(`/TrustmarkPerson`, payload, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }

  update(payload) {
    return HTTP.put(`/TrustmarkPerson`, payload, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }
}

export default new PersonRegistrationService();
